import { IWidget, IWidgetDefinition } from 'src/components/WidgetSettingsModal/widgetSettings.interface';

export type WidgetTitleMap = Record<string, IWidgetDefinition>;

export const WIDGET_SECTION_TYPE = {
    ORDER: 'order',
    QUOTE: 'quote',
    RADAR: 'radar',
} as const;

export const transformWidgets = (widgetsData: any, widgetTitleMap: WidgetTitleMap): IWidget[] => {
    const widgetsArray = Object.entries(widgetsData || {}).map(([widgetId, data]: [string, any]) => ({
        id: widgetId,
        title: widgetTitleMap[widgetId]?.title || 'Unknown Title',
        description: widgetTitleMap[widgetId]?.description || 'No description available',
        icon: widgetTitleMap[widgetId]?.icon,
        isEnabled: data.isEnabled,
        position: data.position,
    }));

    return widgetsArray.sort((a, b) => (a.position || 0) - (b.position || 0));
};

export const transformWidgetsToApiFormat = (widgets: IWidget[]): Record<string, { isEnabled: boolean; position: number }> =>
    widgets.reduce((acc: Record<string, { isEnabled: boolean; position: number }>, widget, index) => {
        acc[widget.id] = {
            isEnabled: widget.isEnabled,
            position: index,
        };

        return acc;
    }, {});
